export default __webpack_public_path__ + "media/collaboration2x.ced10d61.png";